import { render, staticRenderFns } from "./BixLink.vue?vue&type=template&id=2cf333ec&scoped=true&"
import script from "./BixLink.vue?vue&type=script&lang=ts&"
export * from "./BixLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf333ec",
  null
  
)

export default component.exports